<template>
  <v-container>
    <v-row class="mb-3">
      <v-col cols="12" sm="4">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          background-color="white"
          placeholder="ค้นหา"
          v-model="search"
          clearable
          hide-details
        ></v-text-field>
      </v-col>
      <v-col class="text-right">
        <v-btn outlined class="mt-2" color="primary" @click="showFilter = true" :loading="loading">
          <v-icon class="mr-2">mdi-filter</v-icon> กรองข้อมูล
        </v-btn>
        <v-dialog v-model="showFilter" max-width="800">
          <v-card>
            <v-card-text>
              <v-row>
                <v-col>
                  <div class="pt-4 title">กรองข้อมูล</div>
                </v-col>
                <v-col>
                  <div class="text-right py-3">
                    <v-btn fab text small @click="showFilter = false">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <date-filter
                @onSelected="onSelected"
                v-model="selectedDate"
                :default-filter="'today'"
              ></date-filter>

              <v-divider class="my-3" />
              <div class="text-center">
                <v-btn
                  color="primary"
                  depressed
                  @click="
                    showFilter = false;
                    loadOrders();
                  "
                  >ค้นหา</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-tabs class="mb-4" v-model="status" show-arrows>
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab :key="'all'" :href="'#all'"> ทั้งหมด ({{ badges ? badges.all : 0 }}) </v-tab>

      <v-tab :key="'ordered'" :href="'#ordered'">
        รอตรวจสลิป ({{ badges ? badges.ordered : 0 }})
      </v-tab>

      <v-tab :key="'paid'" :href="'#paid'"> จ่ายแล้ว ({{ badges ? badges.paid : 0 }}) </v-tab>

      <v-tab :key="'shipped'" :href="'#shipped'">
        ส่งแล้ว ({{ badges ? badges.shipped : 0 }})
      </v-tab>

      <v-tab :key="'canceled'" :href="'#canceled'">
        ยกเลิก ({{ badges ? badges.canceled : 0 }})
      </v-tab>
    </v-tabs>

    <div class="text-center py-4 " v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div
      v-else-if="filterOrders.length == 0"
      class="text-center py-4 grey lighten-4"
      style="border-radius: 10px"
    >
      No order
    </div>

    <template v-else v-for="order in filterOrders">
      <v-card :key="`order_${order.id}`" outlined class="mb-2">
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="2" class="shrink font-weight-bold">
              Order ID: {{ order.id }}
            </v-col>
            <v-col cols="12" sm="2">
              <v-chip>{{ order.status }}</v-chip>
            </v-col>
            <v-col cols="12" sm="8">
              <div class="font-weight-bold">{{ order.first_name }} {{ order.last_name }}</div>
              {{ order.nameaddress }}
            </v-col>
            <!-- <v-col cols="12" sm="3">083-005-9307</v-col> -->
          </v-row>
        </v-card-text>
        <v-divider />
        <template v-if="showOrderDetail">
          <v-row no-gutters>
            <v-col col="12" sm="6" style="border-right: 1px solid #eee">
              <v-simple-table class="grey lighten-4">
                <template v-slot:default>
                  <thead>
                    <tr class="white">
                      <th class="text-left">
                        ชื่อ
                      </th>
                      <th class="text-center">
                        จำนวน
                      </th>
                      <th class="text-center">
                        ราคา
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <div class="text-xs-center"></div>
                    <template v-for="(productdetail, pindex) in order.productdetail">
                      <tr :key="`productdetail_${pindex}`">
                        <td>{{ productdetail.name }}</td>
                        <td class="text-center">
                          {{ productdetail.quantity }}
                          {{ productdetail.option ? `(${productdetail.option})` : "" }}
                        </td>
                        <td class="text-center">{{ productdetail.price | decimalFormat }} บาท</td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col col="12" sm="6">
              <div class="py-2 caption">
                <v-row no-gutters>
                  <v-col><div class="px-2">ยอดรวม:</div></v-col>
                  <v-col class="text-right"
                    ><div class="px-2">
                      {{
                        (order.total - (order.shippingcharge ? order.shippingcharge : 0))
                          | decimalFormat
                      }}
                      บาท
                    </div></v-col
                  >
                </v-row>
                <v-row no-gutters>
                  <v-col><div class="px-2">ค่าขนส่ง:</div></v-col>
                  <v-col class="text-right"
                    ><div class="px-2">{{ order.shippingcharge | decimalFormat }} บาท</div></v-col
                  >
                </v-row>
                <v-row no-gutters v-if="order.discount">
                  <v-col><div class="px-2">ส่วนลด:</div></v-col>
                  <v-col class="text-right"
                    ><div class="px-2">{{ order.discount | decimalFormat }} บาท</div></v-col
                  >
                </v-row>

                <v-row no-gutters v-if="order.jsonvalue != null && order.jsonvalue.promocode">
                  <v-col><div class="px-2">คูปอง:</div></v-col>
                  <v-col class="text-right"
                    ><div class="px-2">{{ order.jsonvalue.promocode }}</div></v-col
                  >
                </v-row>

                <v-row no-gutters>
                  <v-col><div class="px-2">ยอดรวมทั้งสิ้น:</div></v-col>
                  <v-col class="text-right"
                    ><div class="px-2">{{ order.amount | decimalFormat }} บาท</div></v-col
                  >
                </v-row>
                <v-row no-gutters>
                  <v-col><div class="px-2">ส่งกับ:</div></v-col>
                  <v-col class="text-right"
                    ><div class="px-2">{{ order.shippingtype }}</div></v-col
                  >
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-divider />
        </template>
        <v-btn
          color="primary lighten-3"
          dark
          block
          x-small
          depressed
          tile
          @click="showOrderDetail = !showOrderDetail"
        >
          <v-icon small>{{ !showOrderDetail ? "mdi-chevron-down" : "mdi-chevron-up" }}</v-icon>
          <div class="caption">ดูรายละเอียดออเดอร์</div>
        </v-btn>
      </v-card>
    </template>

    <v-pagination
      class="mt-3"
      color="primary"
      v-model="pageNumber"
      :length="pageCount"
    ></v-pagination>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
const DateFilter = () => import(/* webpackChunkName: "Summary" */ "@/components/DateFilter.vue");
export default {
  data() {
    return {
      badges: null,
      loading: false,
      orders: [],
      search: "",
      status: "all",
      showFilter: false,
      showOrderDetail: false,
      selectedDate: {
        start: moment().format("YYYY-MM-DD 00:00"),
        end: moment().format("YYYY-MM-DD 23:59"),
      },
      pageNumber: 1,
      size: 20,
      shippingOptions: [],
    };
  },
  components: {
    DateFilter,
  },
  computed: {
    filterOrders() {
      const filterOrders = this.onFilterOrders();

      const start = (this.pageNumber - 1) * this.size;
      const end = start + this.size;

      return filterOrders.slice(start, end);
    },
    pageCount: function() {
      let l = this.filterOrders.length;
      let s = this.size;
      return Math.ceil(l / s);
    },
  },
  async mounted() {
    await this.loadOrders();
  },
  methods: {
    async loadOrders() {
      this.loading = true;
      //this.shippingOptions = await this.getShippingOptions();
      var orders = await this.getOrder();
      this.orders = orders;
      this.loading = false;
    },
    onFilterOrders() {
      var orders = this.orders;

      if (this.search != "" && orders) {
        orders = orders.filter((el) => {
          return (
            el.first_name.toLowerCase().includes(this.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(this.search.toLowerCase()) ||
            el.id.toLowerCase().includes(this.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(this.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(this.search.toLowerCase())
          );
        });
      }

      if (orders && orders.length > 0 && this.status != "all") {
        orders = orders.filter((el) => {
          return el.status == this.status;
        });
      }

      return orders;
    },
    async getOrder() {
      this.loading = true;
      try {
        var response = await axios.get(
          `${this.$store.state.serverUrl}chillpainai_ordersummary`,

          {
            params: {
              pageid: this.$store.state.pageid,
              userid: this.$store.state.user.user.userid,
              datefrom: this.selectedDate.start,
              dateto: this.selectedDate.end,
              status: this.status,
            },
            headers: {
              AUTHORIZATION: "BEARER xxx xxx",
            },
          }
        );
        if (response.status == 200 && response.data.responsecode == 200 && response.data.data) {
          var orders = response.data.data;
          this.badges = {
            all: response.data.all,
            canceled: response.data.canceled,
            ordered: response.data.ordered,
            paid: response.data.paid,
            shipped: response.data.shipped,
          };
          return orders.map((el) => {
            var productdetail = [];
            try {
              productdetail = JSON.parse(el.productdetail);
            } catch (error) {
              productdetail = el.productdetail;
            }

            var jsonvalue = [];
            try {
              if (el.jsonvalue) {
                jsonvalue = JSON.parse(el.jsonvalue);
              } else {
                jsonvalue = [];
              }
            } catch (error) {
              //
            }

            return {
              ...el,
              productdetail: productdetail,
              jsonvalue: jsonvalue,
            };
          });
        } else {
          this.orders = [];
        }
      } catch (error) {
        this.orders = [];
      }

      this.loading = false;
    },
    onSelected() {},
    async getShippingOptions() {
      let data = { pageid: this.$store.state.pageid };
      var response = await axios.get(`${this.$store.state.serverUrl}allshipingcharge`, data);
      if (response.state == 200 && response.data.shippinglist) {
        let result = Object.keys(response.shippinglist).map(function(key) {
          return { name: key, ...response.shippinglist[key] };
        });

        return result;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
